import axios from 'axios'

import { BUILDER_CONTENT_API_HOST } from '@/legacy/config/builder'
import { DEFAULT_REQUEST_CONFIG } from '@/legacy/config/request'

export const builderRequest = axios.create({
  baseURL: BUILDER_CONTENT_API_HOST,
  ...DEFAULT_REQUEST_CONFIG,
})
